<template>
  <div>
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <canvas
      id="myChart10"
      width="50"
      height="15"
    />
    <div
      v-if="exibirLegenda"
      id="legendaVendasSomaAnual"
      class="text-center px-3"
    >
      <v-row
        align="center"
        class="ma-0"
      >
        <v-avatar
          class="mr-1"
          color="#cadaed"
          size="10"
        />
        <span class="mr-3 font-weight-light">Faturamento Ano Anterior</span>
        <v-avatar
          class="mr-1"
          color="#4780b8"
          size="10"
        />
        <span class="mr-3 font-weight-light">Faturamento Corrente</span>
      </v-row>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Vendas3 from '../../../../services/vendas3'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardVendas7MesesAnteriores',
    components: {
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      select: [],
      supervisor: [],
      vendedores: [],
      areas: [],
      redes: [],
      receita: [],
      segmento: [],
      classificacoes: [],
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      valorRestante: false,
      loading: false,
      error: null,
      exibirLegenda: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dados: {

      },
      styleObjectvalorRestante: {
        color: '#ed934f',
      },
      montarGrafico: true,
      text: null,
    }),

    created () {
      eventEmit.$on('update-datas-vendas', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-datas-vendas', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, vendedores, areas, redes, receita, segmento, classificacoes) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.vendedores = vendedores
        this.areas = areas
        this.redes = redes
        this.receita = receita
        this.segmento = segmento
        this.classificacoes = classificacoes

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true

        this.exibirLegenda = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Vendas3.showFatMesesDoAno(this.select, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('myChart10').getContext('2d')

            var mobile = !(window.innerWidth < 600)

            this.myChart = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: resposta.data.data,
                datasets: [
                  {
                    label: 'Acumulado AA',
                    data: resposta.data.faturamentoAnoAnterior,
                    backgroundColor: '#cadaed',
                    order: 1,
                  },
                  {
                    label: 'Acumulado',
                    data: resposta.data.faturamentoCorrente,
                    backgroundColor: '#4780b8',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: mobile,
                    color: function (context) {
                      if (context.dataset.label !== 'Porcentagem') {
                        return '#000000'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    rotation: 270,
                    align: 'top',
                    anchor: 'start',
                    offset: 10,
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        var ano = parseFloat(tooltipItem[0].xLabel.slice(-2)) - 1
                        var mes = tooltipItem[0].xLabel.slice(0, -2)

                        tooltipItem[0].xLabel = mes + ano

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há faturamento para comparação') {
            this.text = resposta.data.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Contrato não encontrado') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => {
          this.loading = false

          this.exibirLegenda = true
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass">
  #myChart10
    // margin-top: 6rem

  #legendaVendasSomaAnual
    font-size: 12px
</style>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #myChart10 {
      width: 370px !important;
      height: 124px !important;
      margin: 2rem 0 0 0;
    }

    #legendaVendasSomaAnual {
      font-size: 9px;
      margin: 1rem 0 0 0
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart10 {
      margin: 0 0 0 0;
      width: 700px !important;
      height: 350px !important;
    }

    #legendaVendasSomaAnual {
      font-size: 12px;
      margin: 1rem 0 0 14rem;
    }
  }
</style>
